<template>
  <div class="chaild-task">
    <div class="chaild-task-title">
      <i class="icon iconfont iconicon_subtasks2"></i>
      <span>子任务</span>
      <span class="child-number" v-if="total > 0">{{complete}}/{{total}}</span>
    </div>
    <div class="child-task-box">
      <vuedraggable v-for="(val, key) in childrenList" v-if="typeof val === 'object'" :key="key"  class="task-list-curr" handle=".task-drag-box-icon" element="div" v-bind="dragOptions(key)" :data-key="key" :list="val" @update="end" @add="end">
        <div
          class="child-task-item"
          :data-unread_message_count="item.unread_message_count"
          :data-current_task_unread_message_count="item.current_task_unread_message_count"
          :class="{'complate-style': item.isComplete, 'filed-style': item.task_stage === '已归档'}"
          v-for="(item) in val"
          :key="item.id"
          :data-id="item.id"
        >
          <div class="task-badge" v-if="item.unread_message_count > 0"></div>
          <el-checkbox
            v-model="item.isComplete"
            @change="finishTask(item)"
            :disabled="!item.edit_permission || item.task_stage === '已归档' || isDisabledProject"
          ></el-checkbox>
          <!-- @mouseover="taskMouseOver(item)"
            @mousemove="taskMouseOver(item)"
            @mouseleave="taskMouseLeave(item)" -->
            <LevelStatus style="margin-left: 16px;" v-if="item.sort_rule" :readonly="!item.edit_permission || item.isDisabledProject" v-model="item.sort_rule.sort" @change="saveLevel(item)" :sortList="sortList" />
          <div
            class="task-title"
            :class="{'task-complate-style': item.isComplete}"
            >
            <el-input v-if="item.isEditTitle" class="task-title-input" type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="item.task_name" @keyup.enter.native="setTaskName(item)" :ref="'inputs' + item.id" @focus="isFoucs = true" clearable placeholder="请输入子任务标题" size="mini" maxlength="80"></el-input>
            <toolTip
              v-else
              @click.native="openedTask(item)"
              :ref="'toolTip-'+item.id"
              :maxWidth="item.task_stage === '已归档' ? '228px' : '258px'"
              :title="item.task_name"
            >
              {{item.task_name}}
            </toolTip>
            <span class="archive-icon" v-if="item.task_stage === '已归档'">已归档</span>
          </div>
          <div class="child-time" :class="{'disabled': !item.edit_permission || item.task_stage === '已归档' || isDisabledProject}">
            <div v-if="item.end_time" :class="dateReminder(item)" @click="getTimeBlur(item)">{{item.end_time.replace(/-/g,'/')}}</div>
            <div v-else class="setting-time" @click="getTimeBlur(item)">{{ item.task_stage === '已归档' || !item.edit_permission ? '暂无日期' : '设置日期' }}</div>
            <div class="time-select">
              <wf-date
                placement="bottom"
                type="daterange"
                value-format="yyyy-MM-dd"
                :ref="'endtime' + item.id"
                :picker-options="pickerOptions"
                v-model="item.timeRange"
                @change="saveData(item)"
              >
              </wf-date>
            </div>
          </div>
          <div class="personal" @click="selectMember(item)">
            <Executor
              ref="executor"
              :onlyValue="true"
              :readonly="!item.edit_permission || item.task_stage === '已归档' || isDisabledProject"
              v-model="item.executor_user"
              :defaultValue="item.executor"
              :projectId="item.project_id"
              :parentId="taskId"
              :isTasksRight="true"
              @changeRunMan="changeRunMan"
              :parentExecutorUid="parentExecutorUid"
              :user_in_parent_tasks_permission="item.user_in_parent_tasks_permission"
            ></Executor>
          </div>
          <div class="more" @click.stop="newTask = item" :style="{'visibility': (item.activate_archived_tasks_permission || item.delete_permission || item.archive_permission) && !isDisabledProject? 'visible':'hidden'}">
            <el-dropdown @command="handleCommand" size="small" trigger="click">
              <i class="icon iconfont iconicon_user_more_task"></i>
              <el-dropdown-menu slot="dropdown" class="task-panel-right-more">
                <el-dropdown-item
                  command="archive"
                  v-if="item.archive_permission"
                >
                  <i class="icon iconfont iconicon_move"></i>
                  归档
                </el-dropdown-item>
                <el-dropdown-item
                  command="recover"
                  v-if="item.activate_archived_tasks_permission"
                >
                  <i class="icon iconfont iconicon_restore"></i>
                  恢复未归档
                </el-dropdown-item>
                <el-dropdown-item command="del" v-if="item.delete_permission">
                  <i class="icon iconfont iconicon_recycle_bin"></i>
                  移至回收站
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div  class="group-drag-box-icon task-drag-box-icon" v-if="(isAdmin || editPermission) && !item.isComplete && !isDisabledProject && item.task_stage !== '已归档'">
            <i class="icon iconfont iconicon_drag_order more"></i>
          </div>
        </div>
      </vuedraggable>
      <div class="add-box" v-if="showAddInput">
        <el-input class="add-box-input" type="textarea" :autosize="{ minRows: 1, maxRows: 3}" v-model="inputName" @keyup.enter.native="blurInput($event)" ref="addinputs" @blur="addChildTask" clearable placeholder="请输入子任务标题" size="mini" maxlength="80"></el-input>
      </div>
      <p class="not-thing" v-if="!create_subtask_permission && total === 0">暂无子任务~</p>
      <div class="add-child" @click="addNewTask" v-if="create_subtask_permission && !isDisabledProject">
        <i class="icon iconfont iconicon_enlarge"></i>
        <span>添加子任务</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api/task/task';
import { mapActions } from 'vuex'
import Executor from '@/views/customKeyPage/components/Object/Executor/index.vue'
import vuedraggable from 'vuedraggable'
export default {
  props: ['taskId', 'projectId', 'taskListId', 'templateId', 'parentExecutorUid', 'create_subtask_permission', 'isDisabledProject', 'sortList', 'editPermission'],
  components: {
    Executor,
    vuedraggable
  },
  data() {
    return {
      childrenList: {},
      total: 0,
      taskName: '',
      showAddInput: false,
      newTask: {},
      isEditTitle: false,
      taskNameCopy: '',
      isFoucs: false,
      pickerOptions: {
        shortcuts: [{
          text: '一周',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '清空',
          cellClassName:'date-cancel del-text text-red',
          onClick(picker) {
            picker.$emit('pick', '');
          }
        }]
      },
      hoverTime: 0,
      timer: ''
    }
  },
  computed: {
    complete() {
      return this.childrenList?.compete?.reduce((pre, data) => {
        if (data.task_stage === '已完成' || data.task_stage === '已归档') {
          return pre + 1
        } else {
          return pre
        }
      }, 0) || 0
    },
    inputName: {
      get: function (val) {
        return this.taskName
      },
      set: function (value) {
        this.taskName = value ? value.replace(/\s+|[\r\n]/g, "") : ''
      }
    }
  },
  filters: {
    capitalize(val) {
      return val.replace(/\s+|[\r\n]/g, "")
    }
  },
  mounted() {
    this.getChildrenDetail()
  },
  methods: {
    ...mapActions('task/task', ['updateFormKey']),
    dragOptions(key) {
      return {
        animation: 200,
        group: key
      }
    },
    async addChildTask() {
      if (this.taskName) {
        let params = {
          pid: this.taskId,
          task_name: this.taskName,
          executor: '',
          standard_components_values: '',
          project_id: this.projectId,
          task_list_id: this.taskListId,
          sort_rule_id: 2,
          task_members: '',
          task_stage: '未开始',
          template_id: this.templateId
        }
        await api.saveTaskatNew(params)
        this.getChildrenDetail()
      }
      this.taskName = ''
      this.showAddInput = false
      this.$emit('change')
    },
    async getChildrenDetail() {
      const params = {
        number: 999,
        page: 1,
        parent_task_id: this.taskId
      }
      const res = await api.childrenTasksIndex(params)
      if (res) {
        if (res.data && res.data.length) {
          const _list = JSON.parse(JSON.stringify(res.data))
          let result = {
            level4: [],
            level3: [],
            level2: [],
            level1: [],
            compete: []
          }
          _list.forEach((item) => {
            item.isComplete = item.task_stage === '已归档' ? item.before_archiving_is_completed : this.getStatusTxt(item.task_stage)
            item.timeRange = item.start_time ? [item.start_time, item.end_time] : []
            item.isEditTitle = false
            if(item.task_stage === '已完成' || item.task_stage === '已归档') {
              result.compete.push(item)
            } else {
              result["level" + item.sort_rule.sort] ? result["level" + item.sort_rule.sort].push(item) : (result["level" + item.sort_rule.sort] = [item]);
            }
          })
          this.total = res.total

          // _list.forEach(item => {
          //   item.isComplete = item.task_stage === '已归档' ? item.before_archiving_is_completed : this.getStatusTxt(item.task_stage)
          //   item.timeRange = item.start_time ? [item.start_time, item.end_time] : []
          //   item.isEditTitle = false
          // })
          // // 将子任务列表根据是否已归档进行排序，已归档的排后面
          this.childrenList = result
        } else {
          this.childrenList = {}
          this.total = 0
        }
        this.$emit('finish')
      }
    },
    async finishTask(item) {
      if (item.task_stage === '已归档') return
      let newVal = item.isComplete ? '已完成' : '进行中'
      await api.updateTaskStage({ task_id: item.id, task_stage: newVal })
      this.$emit('change')
      this.getChildrenDetail()
    },
    dateReminder(item) {
      let nowTime = new Date().getTime()
      let remind = 3 * 24 * 60 * 60 * 1000
      let expired = 24 * 60 * 60 * 1000
      if (item.task_stage === '已归档' || (item.task_stage === '已归档' ? item.before_archiving_is_completed : this.getStatusTxt(item.task_stage))) {
        return 'complete-time complete'
      }
      if (new Date(item.end_time).getTime() + expired < nowTime) {
        return 'complete-time expired'
      } else if (new Date(item.end_time).getTime() < nowTime) {
        return 'complete-time remind'
      } else {
        return 'complete-time'
      }
    },
    async deletedTask() {
      this.$wfAlert('warning', '确认需要删除该任务?', '', '确定').then(async () => {
        const res = await api.delTask({ task_id: this.newTask.id })
        if (res) {
          this.$message({
            message: '删除任务成功',
            type: 'success'
          })
          this.getChildrenDetail()
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    handleCommand(command) {
      if (command === "edit") {
        this.openedTask(this.newTask)
      }
      if (command === "del") {
        this.deletedTask()
        // this.$emit('change')
      }
      if (command === 'archive') {
        // 归档任务
        this.$emit('handleArchive', this.newTask.id, 'archive')
      }
      if (command === 'recover') {
        // 恢复为未归档任务
        this.$emit('handleArchive', this.newTask.id, 'recover')

      }
    },
    addNewTask() {
      this.showAddInput = true
      this.$nextTick(() => {
        this.$refs.addinputs.focus()
      })
    },
    getTimeBlur(item) {
      if (!item.edit_permission || item.task_stage === '已归档' || this.isDisabledProject) return
      this.$nextTick(() => {
        this.$refs['endtime' + item.id][0].focus()
      })
    },
    async saveData(item) {
      await this.updateFormKey({
        task_id: item.id,
        data: {
          start_time: item.timeRange[0],
          end_time: item.timeRange[1]
        }
      })
      this.$emit('change')
      this.getChildrenDetail()
    },
    async saveLevel(item) {
      await this.updateFormKey({
        task_id: item.id,
        data: {
          sort_rule_id: item.sort_rule.sort
        }
      })
      this.$emit('change')
      this.getChildrenDetail()
    },
    async setTaskName(item) {
      item.isEditTitle = false
      clearTimeout(this.timer)
      if (item.task_name === this.taskNameCopy) {
        return
      }
      await this.updateFormKey({
        task_id: item.id,
        data: {
          task_name: item.task_name
        }
      }).catch(err => {
        this.getChildrenDetail()
      })
      this.$emit('change')
    },
    taskMouseOver(item) {
      if (!item.edit_permission || this.isFoucs || item.task_stage === '已归档') return
      this.taskNameCopy = item.task_name
      this.debounce(() => {
        item.isEditTitle = true
        this.$refs['toolTip-' + item.id][0] ? this.$refs['toolTip-' + item.id][0].clear() : ''
        this.$nextTick(() => {
          this.$refs['inputs' + item.id] ? this.$refs['inputs' + item.id][0].focus() : ''
        })
      }, 1000)
    },
    taskMouseLeave(item) {
      this.isFoucs = false
      clearTimeout(this.timer)
      item.isEditTitle = false
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    async changeRunMan(item) {
      let task_members = this.newTask.task_members_user.map(res => res.uid)
      if (!task_members || task_members.length === 0 || !(task_members.indexOf(item.uid) > -1)) {
        task_members.push(item.uid)
      }
      let params = {
        task_id: this.newTask.id,
        data: {
          task_members,
          executor: item.uid
        }
      }
      await this.updateFormKey(params)
      this.$emit('change')
      this.getChildrenDetail()
    },
    selectMember(item) {
      this.newTask = item
    },
    openedTask(item) {
      this.$emit('openedTask', item)
    },
    blurInput(e) {
      e.preventDefault()
      this.showAddInput = false
      this.$refs.addinputs.blur()
    },
    end(event) {
      console.log(event.target.dataset)
      let group = event?.target?.dataset?.key
      let task_id = event.item.dataset.id * 1;
      let index = this.childrenList[group].findIndex(res => res.id == task_id)
      let previous_task_id = index - 1 < 0 ? 0 : this.childrenList[group][event.newIndex - 1].id
      let params = {
        task_id,
        previous_task_id,
      };
      api.updateTaskSort(params).then((res) => {
        this.$message({
          message: '修改成功',
          type: 'success',
        });
      });
    }
  }
}
</script>

<style>
@keyframes fade {
  from {
    background-color: rgba(80, 154, 255, 0.6);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 1;
    background-color: inherit;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.chaild-task {
  .child-task-box {
    border: 1px solid rgba(32, 32, 32, 0.08);
    border-radius: 4px;
    padding-top: 5px;
    .not-thing {
      margin: 0 16px;
      color: #999;
      height: 54px;
      line-height: 54px;
    }
  }
  .child-task-item {
    padding: 0 16px;
    position: relative;
    min-height: 48px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    // cursor: pointer;
    // margin-top: 8px;
    transition: all 0.3s;
    &:hover {
      @include bgColorOpacity(.04);
      .group-drag-box-icon {
        display: block;
      }
    }
    &:active {
      @include bgColorOpacity(.08);
    }
    .group-drag-box-icon {
      display: none;
      i {
        font-size: 14px;
      }
    }
    .tool-tip-content,
    .child-time,
    .more {
      cursor: pointer;
    }
    .personal {
      cursor: pointer;
      margin-right: 18px;
      width: 28px;
      height: 28px;
      position: relative;
      flex-shrink: 0;
      .hover-style {
        padding: 0;
        &:active {
          background-color: initial;
        }
        &:hover {
          background-color: initial;
        }
      }
      .avatar-box {
        margin: 0 !important;
      }
      .executor {
        height: auto;
      }
      .Executor {
        padding: 0;
        width: 100%;
        height: 100%;
        &:hover {
          background-color: initial;
        }
      }
    }
    .child-time {
      width: 88px;
      height: 32px;
      border-radius: 4px;
      margin: 0 8px;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      position: relative;
      @include fontColorOpacity(.6);
      &:hover {
        @include bgColorOpacity(.06);
      }
      &:active {
        @include bgColorOpacity(.12);
      }
      &.disabled {
        cursor: not-allowed;
        &:hover {
          background: initial;
        }
        &:active {
          background: initial;
        }
      }
      .time-select {
        visibility: hidden;
        margin: 0;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        .el-date-editor {
          height: 100%;
          box-sizing: border-box;
        }
      }
    }
    .task-title {
      padding-left: 16px;
      box-sizing: border-box;
      flex: 1;
      width: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      &:hover {
        color: $color-active;
      }
      .task-title-input {
        font-size: 14px;
        .el-textarea__inner {
          padding: 4px 8px !important;
          height: 32px;
        }
      }
    }
    // .task-complate-style {
    //   color: rgba(32, 32, 32, 0.4);
    // }
    .archive-icon {
      display: block;
      width: 46px;
      height: 20px;
      @include bgColorOpacity(.06);
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      @include fontColorOpacity(.4);
      margin-left: 8px;
      flex-shrink: 0;
    }
    .task-badge {
      width: 6px;
      height: 6px;
      background: linear-gradient(270deg, #6b97cf 0%, #456fb3 100%);
      border-radius: 50%;
      margin-right: 10px;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 4px;
    }
    .more {
      padding: 0;
      margin: 0 !important;
      border-radius: 4px;
    }

    &.filed-style,
    &.complate-style {
      // &.filed-style {
      //   @include bgColorOpacity(.08);
      //   &:hover {
      //     @include bgColorOpacity(.08);
      //   }
      // }
      @include fontColorOpacity(.4);
      .task-title {
        &:hover {
          color: #202020;
        }
      }
      .child-time {
        cursor: auto;
        @include fontColorOpacity(.4);
        &:hover {
          background: none;
        }
        .complete-time {
          @include fontColorOpacity(.4);
        }
      }
      .personal {
        opacity: .4;
      }
    }
  }
  // .complate-style {
  //   > * {
  //     opacity: 0.4;
  //   }
  //   .el-checkbox {
  //     opacity: 1;
  //   }
  //   .more {
  //     opacity: 1;
  //   }
  // }
  .add-box {
    min-height: 32px;
    margin-top: 8px;
    line-height: 32px;
    padding: 0 16px;
    .el-textarea__inner {
      min-height: 32px !important;
      height: 32px !important;
      font-size: 14px;
      padding: 4px 8px !important;
    }
  }
  .add-child {
    display: flex;
    font-size: 14px;
    align-items: center;
    color: $color-active;
    cursor: pointer;
    display: inline-block;
    padding-left: 16px;
    height: 54px;
    line-height: 54px;
    i {
      margin-right: 8px;
      font-size: inherit;
    }
  }
  .not-primission {
    margin-top: 8px;
  }
  .chaild-task-title {
    font-size: 16px;
    line-height: 1;
    padding-top: 24px;
    padding-bottom: 16px;
    i {
      margin-right: 6px;
    }
  }
  .child-number {
    @include fontColorOpacity(.6);
    font-size: 14px;
    margin-left: 10px;
  }
}
</style>
